// extracted by css-extract-rspack-plugin
var _1 = "useDialog-m_body-k_HhA4jN";
var _2 = "useDialog-m_buttons-_jbJkzRV";
var _3 = "useDialog-m_dialog-gyFDHFsr";
var _4 = "useDialog-m_title-x7Tq91rL";
export { _1 as "body", _2 as "buttons", _3 as "dialog", _4 as "title" }
